import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import MainIce from './TechnicalEquipForm/MainIce';
import FormIce from './TechnicalEquipForm/FormIce';

// Utils
import {
  getDataWithComp,
  getAlert,
  getClearLocalStorage,
  getMaxTeNo
} from '../../../utils/SamuiUtils';

const TechnicalEquipFormIce = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [maxTeNo, setMaxTeNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('API_1601_WTDOC_H', 'AND WTDoc_Type = 6 ORDER BY WTDoc_Date DESC');
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);

      }
      const detailList = await getDataWithComp('API_1602_WTDOC_D', `AND WTDocType_Name = 'Tech Equip' ORDER BY WTDoc_Date DESC`);
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // หาค่าสูงของ WTDocNo ใน WTDoc_H สำหรับ TE (ใบเบิกอุปกรณ์ช่าง)
      const findMaxTeNo = await getDataWithComp('WTDoc_H', `AND WTDoc_Type = '6' ORDER BY WTDoc_No DESC`);
      const maxTe = getMaxTeNo(findMaxTeNo);
      setMaxTeNo(maxTe);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onChangeMode = (mode) => {
    return () => setMode(mode);
  };

  const onPageUpdate = (wtDocNo) => {
    setMaxTeNo(wtDocNo);
    setMode('U');
  };

  return (
    <div>
      <div className="TreasuryDocuments">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <MainIce
                    name={'ใบเบิกอุปกรณ์ช่าง'}
                    onChangeMode={onChangeMode}
                    onPageUpdate={onPageUpdate}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                  />
                ) : (
                  <FormIce
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบเบิกอุปกรณ์ช่าง'}
                    wtDocNo={maxTeNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalEquipFormIce;
